import React from 'react'
import './infobox.css'
import {Card ,CardContent,Typography} from '@material-ui/core'

function infobox({title ,cases,isRed ,active,total,...props}) {
    return (
        <Card className={`infoBox ${active && "infoBox--selected" } ${isRed && "infoBox--red"}`} onClick={props.onClick}>
             <CardContent>
                <Typography color="textSecondary"> 
          {title}
                </Typography>
       <h2 className={`infoBox_cases ${!isRed && "infoBox_cases--green"}`} >{cases}</h2>
        <Typography className="infoBox_total">
           <h4>Total</h4> {total}
        </Typography>


             </CardContent>

        </Card>
    )
}

export default infobox
